import { gql } from '@apollo/client';

export const ANNOUNCEMENT_BANNER_FIELDS = gql`
    fragment AnnouncementBannerFields on AnnouncementBanner {
        id
        key
        title
        message
        variant
        audience
        allowedPlanTypes
        status
        priority
        startsAt
        primaryEndsAt
        hideAt
        ctaLabel
        ctaUrl
        afterEndMessage
        afterEndCtaLabel
        afterEndCtaUrl
        dismissibleLoggedIn
        dismissibleLoggedOut
        createdAt
        updatedAt
    }
`;

export const ACTIVE_ANNOUNCEMENT_BANNER = gql`
    ${ANNOUNCEMENT_BANNER_FIELDS}
    query ActiveAnnouncementBanner {
        activeAnnouncementBanner {
            ...AnnouncementBannerFields
        }
    }
`;

export const ANNOUNCEMENT_BANNERS = gql`
    ${ANNOUNCEMENT_BANNER_FIELDS}
    query AnnouncementBanners {
        announcementBanners {
            ...AnnouncementBannerFields
        }
    }
`;

export const CREATE_ANNOUNCEMENT_BANNER = gql`
    ${ANNOUNCEMENT_BANNER_FIELDS}
    mutation CreateAnnouncementBanner($data: AnnouncementBannerInput!) {
        createAnnouncementBanner(data: $data) {
            ...AnnouncementBannerFields
        }
    }
`;

export const UPDATE_ANNOUNCEMENT_BANNER = gql`
    ${ANNOUNCEMENT_BANNER_FIELDS}
    mutation UpdateAnnouncementBanner($id: ID!, $data: UpdateAnnouncementBannerInput!) {
        updateAnnouncementBanner(id: $id, data: $data) {
            ...AnnouncementBannerFields
        }
    }
`;

export const DELETE_ANNOUNCEMENT_BANNER = gql`
    mutation DeleteAnnouncementBanner($id: ID!) {
        deleteAnnouncementBanner(id: $id)
    }
`;
